import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { ImporterRun } from 'dashboard/models/importer-run';
import { ImporterRunsActions, ImporterRunsActionType } from 'dashboard/redux/actions/importer-runs';

export type ImporterRuns = ImporterRun[];

export interface ImporterRunsState extends Omit<Omit<TableState<{}>, 'sortParams'>, 'filters'> {
  importerRuns: ImporterRuns;
}

const initialState: ImporterRunsState = {
  importerRuns: [],
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (state: ImporterRunsState = initialState, action: ImporterRunsActions) => {
  switch (action.type) {
    case ImporterRunsActionType.SaveImporterRun: {
      return {
        ...state,
        importerRuns: [
          ...state.importerRuns.filter((x) => x.id !== action.payload.importerRun.id),
          action.payload.importerRun,
        ],
      };
    }

    case ImporterRunsActionType.SaveImporterRuns: {
      return {
        ...state,
        importerRuns: action.payload.importerRuns,
        paginationParams: action.payload.paginationParams,
      };
    }

    case ImporterRunsActionType.SavePageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case ImporterRunsActionType.SaveCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    default:
      return state;
  }
};
